import React from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
const RFQMenu = () => {
 
  return (
    <div > 
      
     <Navbar style={{backgroundColor:"#2F9DCC"}} className='d-flex justify-content-left'>
    
          <Nav>
            <Nav.Link as={Link} to="/Dashboard" className='text-white'>Home</Nav.Link>
             <Nav.Link as={Link} to="/ApprovedPolicySubmissions" className='text-white'>Approved Policy Submissions</Nav.Link>
            <Nav.Link as={Link} to="/Reject PolicySubmissions" className='text-white'> Reject  Policy Submissions </Nav.Link>
            <Nav.Link as={Link} to="/ModifyPolicySubmissions" className='text-white'>Modify Policy Submissions</Nav.Link>
            <Nav.Link as={Link} to="/RenewalsandCancellationspolicies." className='text-white'>Renewals and Cancellations policies</Nav.Link>
          </Nav>
          </Navbar>
    
    </div>
  )
}

export default RFQMenu
